<template>
  <div>
    <div class="py-1" v-for="[k, v] of summary.filter(([_, v]) => v)" :key="k">
      <div class="text-xs font-bold">{{k}}</div>
      <div class="text-sm text-gray-500">{{v}}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import languages from '@/lib/languages.json'

export default {
  computed: {
    ...mapGetters(['profile', 'user']),
    summary() {
      let name = null
      if(this.profile.givenname !== undefined && this.profile.familyname !== undefined) {
        name = `${this.profile.givenname} ${this.profile.familyname}`
      } else if(this.profile.givenname !== undefined) {
        name = this.profile.givenname
      } else if(this.profile.familyname) {
        name = this.profile.familyname
      }

      return [
        ['Nome', name],
        ['Nome utente', this.user.displayName],
        ['Anno di nascita', this.profile.birthyear],
        ['Titolo di studio', this.$t('degrees.' + this.profile.degree)],
        ['Nazione', this.$t('countries.' + this.profile.country)],
        ['Comune di residenza', this.profile.residence ? this.profile.residence.name : null],
        ['Lingua principale', languages[this.profile.mainLanguage]],
        ['Altre lingue', this.profile.otherLanguages ? this.profile.otherLanguages.map(lc => languages[lc]).join(', ') : null]
      ]
    }
  }
}
</script>

<style>

</style>